import { render } from "./BannerVisual.vue?vue&type=template&id=04a1f974&scoped=true"
import script from "./BannerVisual.vue?vue&type=script&lang=js"
export * from "./BannerVisual.vue?vue&type=script&lang=js"

import "./BannerVisual.vue?vue&type=style&index=0&id=04a1f974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a1f974"]])

export default __exports__